export default __webpack_public_path__ + "static/media/CEDES-04.7ca960e6.jpg";